/** Base path of the internal service request V2 pages, as registered in `Routes.constant.ts`. */
export const INTERNAL_SERVICE_REQUEST_BASE_PATH = '/v2/isr';

/** Create route of the internal service request V2 page. */
export const INTERNAL_SERVICE_REQUEST_CREATE_PATH = `${INTERNAL_SERVICE_REQUEST_BASE_PATH}/create`;

/** Edit route of the internal service request V2 page; takes the edited record's id. */
export const INTERNAL_SERVICE_REQUEST_EDIT_PATH = `${INTERNAL_SERVICE_REQUEST_BASE_PATH}/edit`;

/** Copy route of the internal service request V2 page; takes the id of the record to copy from. */
export const INTERNAL_SERVICE_REQUEST_COPY_PATH = `${INTERNAL_SERVICE_REQUEST_BASE_PATH}/copy`;
